import React from "react";
import onHandItemInputStyles from "../../../on-hand/components/item/OnHandItemInput.module.css";

const OnHandFoodItemDelivery = () => {
    return <div className={onHandItemInputStyles.Delivery} />;
};

export default OnHandFoodItemDelivery;
